<template>
    <div>
        <a class="cursor-pointer" @click="open = true">
            <slot></slot>
        </a>

        <portal to="modals">
            <modal v-if="open" @close="open = false">
                <h3 slot="header">Create a new Data Selection</h3>
                <div class="flex flex-col ">
                    <div class="w-full">
                        <a href="/en/sources" class="rounded cursor-pointer p-4 mb-8 mr-8 block hover:bg-blue-lighter hover:border-blue-dark flex text-blue-dark">
                            <div class="p-2">
                                <i class="fa fa-2x fa-fw fa-book"></i>
                            </div>
                            <div>
                                <div class="leading-normal uppercase">
                                    Search and Merge the Data you need
                                </div>
                                <div class="text-grey-dark text-sm">
                                    Use AllThatStats data library to find data that suits your needs.
                                </div>
                            </div>

                        </a>
                    </div>
                    <div class="w-full">
                        <a href="/en/analysis/import" class="rounded cursor-pointer p-4 mb-8 mr-8 block hover:bg-blue-lighter hover:border-blue-dark flex text-blue-dark">
                            <div class="p-2">
                                <i class="fa fa-2x fa-fw fa-upload"></i>
                            </div>
                            <div>
                                <div class="leading-normal uppercase">
                                    Upload Data
                                </div>
                                <div class="text-grey-dark text-sm">
                                    Import your data for a quick analysis or to update your time series with more recent data.
                                </div>
                            </div>

                        </a>
                    </div>
                    <!--<div class="w-1/3">
                        <a href="/en/analysis/import" class="mb-8 mr-8 shadow block h-64 hover:bg-blue-lighter p-4">
                            Import Data
                        </a>
                    </div>-->
                </div>
            </modal>
        </portal>
    </div>
</template>

<script>

    import Modal from "../dashboard/components/Modal"

    export default {
        components: {
            Modal
        },

        data() {
            return {
                open: false,
            }
        }

    }

</script>